require.register("documenteditor/controllers/bildnrsCtrl", function(exports, require, module){
  $0
  
});

